const userInfo = () => {
  const userinfo = localStorage.getItem('user')
  if (!userinfo) return null
  try {
    return JSON.parse(userinfo)
  } catch (e) {
    return null
  }
}

export default userInfo
